<!--TODO: thumbnails instead of photos when old posts expired-->
<img *ngFor="let currentPhoto of post.thumbnails | keyvalue" alt="photo du cheval"
    [src]="currentPhoto.value" [ngClass]="getImageClassname(currentPhoto.key)">
<span class="counter" *ngIf="post.thumbnails.length>1">{{this.selectedIndex+1}}/{{this.post.thumbnails.length}}</span>
<a *ngIf="post.thumbnails.length>1" class="prev" (click)="plusSlides(-1)">&#10094;</a>
<a *ngIf="post.thumbnails.length>1" class="next" (click)="plusSlides(1)">&#10095;</a>
<mat-icon class="horse__photo" *ngIf="!post.thumbnails" svgIcon="horse-placeholder" aria-hidden="false"
    aria-label="photo du cheval manquante"></mat-icon>
<span class="photo__text" *ngIf="!post.thumbnails" aria-hidden="false">photo du cheval manquante</span>
